module.exports = __webpack_public_path__ + "static/media/a-purple-space-background.9e968c64.jpg";